module.exports = __webpack_public_path__ + "static/img/kv_title_2027.8e5901f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/kv_title_2027.png
// module id = IRhv
// module chunks = 0